export default "__VITE_ASSET__D0hGPIn1__"